module.exports = __webpack_public_path__ + "static/media/team-member-04.0a817cc6.jpg";